"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var autoLinkFeatures_1 = require("./features/autoLinkFeatures");
var cursorFeatures_1 = require("./features/cursorFeatures");
var entityFeatures_1 = require("./features/entityFeatures");
var listFeatures_1 = require("./features/listFeatures");
var markdownFeatures_1 = require("./features/markdownFeatures");
var quoteFeatures_1 = require("./features/quoteFeatures");
var shortcutFeatures_1 = require("./features/shortcutFeatures");
var structuredNodeFeatures_1 = require("./features/structuredNodeFeatures");
var tableFeatures_1 = require("./features/tableFeatures");
var allFeatures = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, listFeatures_1.ListFeatures), quoteFeatures_1.QuoteFeatures), tableFeatures_1.TableFeatures), structuredNodeFeatures_1.StructuredNodeFeatures), autoLinkFeatures_1.AutoLinkFeatures), shortcutFeatures_1.ShortcutFeatures), cursorFeatures_1.CursorFeatures), markdownFeatures_1.MarkdownFeatures), entityFeatures_1.EntityFeatures);
/**
 * Get all content edit features provided by roosterjs
 */
function getAllFeatures() {
    return allFeatures;
}
exports.default = getAllFeatures;
//# sourceMappingURL=getAllFeatures.js.map